import React, { Component } from 'react';
import './index.less';

class Home extends Component {
    componentDidMount() {
        document.title = '新华英才笔试'
    }
    render() {
        return (
            <div className="exame">
                <div className="exame__item exame__banner">
                    <div className="exame__banner-login">
                        <a href="//talent.chinahr.com/" target="_blank" rel="noreferrer">登录</a>
                    </div>
                </div>
                <div className="exame__item exame__content01"></div>
                <div className="exame__item exame__content02"></div>
                <div className="exame__item exame__content03"></div>
                <div className="exame__item exame__content04"></div>
                <div className="exame__item exame__content05"></div>
                <div className="exame__item exame__content06"></div>
                <div className="exame__item exame__phone"></div>
            </div>
        );
    }
}

export default Home;